export const STORAGE_KEYS = {
  LANGUAGE: 'i18nextLng',
} as const

export const KEY_LANGS = {
  VI: 'vi-south',
  EN: 'en',
} as const

export * from './admin-scope'
export * from './auth'
export * from './css-color-names'
export * from './destination-form'
export * from './dashboard'
export * from './date-format'
export * from './http'
export * from './location'
export * from './map'
export * from './media'
export * from './pagination'
export * from './password'
export * from './poi-categories'
export * from './poi-form'
export * from './poi-status'
export * from './poi-type'
export * from './status'
export * from './theme-colors'
export * from './timing'
export * from './tour-categories'
export * from './tour-form'
export * from './tour-transport'
export * from './translation-status'
